import { useFormContext } from "react-hook-form";

import TextArea from "~/common/components/ui/Textarea";
import { QUESTION_TEXT_MAX_CHARACTERS } from "~/providers/constants/supplementalQuestions";
import { AddQuestionForm } from "~/providers/types/supplementalQuestions";

export const FreeTextQuestionFields = () => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<AddQuestionForm>();

  return (
    <TextArea
      label="Question text"
      rows={5}
      {...register("text")}
      charactersCount={watch("text")?.length}
      maxCharacters={QUESTION_TEXT_MAX_CHARACTERS}
      error={errors.text?.message}
    />
  );
};
